var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-person-template',{attrs:{"action":_vm.action,"column":"person2","grid":"person2","title":"Receveur"}})
}
var staticRenderFns = []

export { render, staticRenderFns }